export default (innerSectionLabel, productsCode) => {
  const innerData = productsCode.reduce((acc, curr) => {
    acc[curr] = curr;
    return acc;
  }, {});
  return { [innerSectionLabel]: innerData };
};
